export default __webpack_public_path__ + "static/media/tick.9baa343f.png";